import type { ReactNode } from 'react';
import { Platform, View } from 'react-native';
import { router } from 'expo-router';
import { Printer } from 'lucide-react-native';
import { colors } from '@hogar/shared';
import { Button, Screen, useT } from './ui';
import { printSheet } from '../lib/print';

/**
 * A printable page. In the browser, the phone's or computer's own "print or save as PDF" does the
 * job (lib/print.ts makes it flow over several pages, in columns). The installed apps get their
 * own PDF at milestone 6.
 */
export function Paper({ children }: { children: ReactNode }) {
  const { t } = useT();
  return (
    <Screen>
      <View
        nativeID="print-sheet"
        style={{
          backgroundColor: colors.white,
          borderRadius: 6,
          padding: 22,
          shadowColor: '#000',
          shadowOpacity: 0.08,
          shadowRadius: 12,
          shadowOffset: { width: 0, height: 4 },
          elevation: 3,
        }}
      >
        {children}
      </View>
      {Platform.OS === 'web' && <Button label={t('print')} Icon={Printer} onPress={printSheet} style={{ marginTop: 18 }} />}
      <Button label={t('back')} variant="outline" onPress={() => (router.canGoBack() ? router.back() : router.replace('/'))} style={{ marginTop: 10 }} />
    </Screen>
  );
}

export function Box({ checked }: { checked?: boolean }) {
  return (
    <View style={{ width: 14, height: 14, borderWidth: 1.2, borderColor: checked ? colors.primary : '#9AA19C', borderRadius: 2, backgroundColor: checked ? colors.primary : 'transparent' }} />
  );
}
